import Store from 'store'

class LoggedInUser {
  static getInfo = () => Store.get('swipecast_info');
  static setInfo = (userInfo) => Store.set('swipecast_info', userInfo);

}

export default LoggedInUser;
